import React, { useEffect, useState } from 'react';
import { BiMessageSquareEdit, BiTrash } from "react-icons/bi";
import { connect } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import { deleteProject, editProject, fetchProject } from '../../redux/actions/project';
import EditProjectModal from './EditProjectModal';

const ManageProjectTable = ({dispatch, projects}) => {
  const [modalShow, setModalShow] = useState(false);
  const [changedField, setChangedField] = useState({id:'', projectname:'', description:'', collectionSize:'', mintPrice:'', mintRevenue:'', teamStatus:'', website:'', twitter:'', twitterFollowers:'', discord:'', discordMember:'', megiceden:'',  summary:''  });

  projects.sort((a,b)=>a.projectname.toLowerCase().trim().localeCompare(b.projectname.toLowerCase().trim()))
  
const [modalType] = useState('edit');
    const { addToast } = useToasts();

    const toggleModal = () => setModalShow(!modalShow);

  const handleSubmit= ()=>{
    dispatch(editProject(changedField, addToast))
    setModalShow(false)
  }
    useEffect(()=>{
        dispatch(fetchProject())
       },[dispatch])

       const handleEdit=(project)=>{
        
        setChangedField(prev=>({...prev, id:project._id, projectname: project.projectname, description: project.description, collectionSize: project.collectionSize, mintPrice: project.mintPrice, mintRevenue: project.mintRevenue, teamStatus:project.teamStatus, website: project.website, twitter: project.twitter, twitterFollowers: project.twitterFollowers, discord: project.discord, discordMember: project.discordMember, megiceden: project.megiceden, summary: project.summary}))
        setModalShow(true)
       }

       const handleDelete = (id) => {
        dispatch(deleteProject(id, addToast))
       }


    return (
      <>
        <section className="author-area">
          <div className="container">
          

          <table className="table table-secondary table-hover table-responsive-lg">
  <thead>
    <tr className=''>
      
      <th scope="col">Image</th>
      <th scope="col">Project Name</th>
      <th scope="col">Desc</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody>
    {projects && projects.map(project=>(
        <tr key={project._id}>
        <td><img src={project.image} width={45} height={45} alt={project.projectname} /></td>
        <td>{project.projectname}</td>
        <td>{project.description.slice(0,70)}</td>
        <td className='table-action'>
          <span onClick={()=>handleEdit(project)} className='mr-2 edit'><BiMessageSquareEdit/></span>
          <span onClick={()=>handleDelete(project._id)} className='delete'><BiTrash/></span>
        </td>
      </tr>
    ))}
   
    
  </tbody>
</table>
          </div>
        </section>

        {modalShow && <EditProjectModal  show={modalShow} changedField={changedField} setChangedField={setChangedField} modalType={modalType} toggle={toggleModal} handleSubmit={handleSubmit}/>}
      </>
    );
};


function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      projects: state.project.projectData
    };
  }

export default connect(mapStateToProps)(ManageProjectTable);
